import { toApiClient } from './toApiClient';

const rfaApi = toApiClient(process.env.GATSBY_RFA_API_BASE_URL || '');

export default rfaApi;
